import { useCallback, useEffect, useState } from 'react';
import { inlineHelpStore, getInlineHelpStoreValue } from '../store/inlineHelpStore';
import usePageHistory from './usePageHistory';
import { resetContentStore } from '../store/inlineHelpContentStore';

function useInlineHelp() {

  const [pageId, setPageId] = useState(
    getInlineHelpStoreValue().pageId
  );
  const {resetPageHistory, pushtoPageHistory, popLastVisitedPage } = usePageHistory();

  useEffect(() => {
    const subscription = inlineHelpStore.subscribe(
      updatedValue => setPageId(updatedValue.pageId)
    );
    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, []);

  const openInlineHelpSheet = useCallback((id: string) => {
    inlineHelpStore.next({ pageId: id});
  }, []);

  const navigateToNextPage = useCallback((id: string) => {
    if (pageId) {
      pushtoPageHistory(id);
    } 
    openInlineHelpSheet(id);
  }, []);

  const navigateToPrevPage = useCallback(() => {
    const prevOpenedPage = popLastVisitedPage();
    if (prevOpenedPage) {
      openInlineHelpSheet(prevOpenedPage);
    }
  }, [openInlineHelpSheet, popLastVisitedPage]);

  const closeInlineHelpSheet = useCallback(() => {
    resetPageHistory();
    resetContentStore();
    inlineHelpStore.next({
      pageId: null
    });
  }, []);

  return {
    pageId,
    openInlineHelpSheet,
    closeInlineHelpSheet,
    navigateToNextPage,
    navigateToPrevPage
  };
}

export default useInlineHelp;